var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"AboutBlockWrapper"},[_c('AboutTitle'),_c('AboutPicGrid'),_c('MobilePicSlider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }